export default "__VITE_ASSET__D6z2SekT__"